// ErrorContext.js
import React, { createContext, useState, useContext } from "react";
import { Alert, Snackbar } from "@mui/material";

// Create context
const SuccessContext = createContext();

// Custom hook to use the ErrorContext
export const useSuccess = () => {
  return useContext(SuccessContext);
};

// ErrorProvider component to wrap your app
export const SuccessProvider = ({ children }) => {
  const [message, setMessage] = useState(null);

  const showMessage = (message) => {
    setMessage(message);
  };

  const hideMessage = () => {
    setMessage(null);
  };

  return (
    <SuccessContext.Provider value={{ showMessage, hideMessage }}>
      {children}

      {/* Snackbar for global error alert */}
      <Snackbar
        open={Boolean(message)}
        autoHideDuration={6000}
        onClose={hideMessage}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={hideMessage} severity="success" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </SuccessContext.Provider>
  );
};
